import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import Paragraph from 'app_previous/elements/typography/paragraph';
import { IStaticContentfulImages } from 'src/types/contentful';
import { FormResultContainer } from './HubspotEmailCaptureFormResult.styles';

interface HubspotFormResultProps {
  result: 'success' | 'failure';
}

const HubspotFormResult = ({ result }: HubspotFormResultProps): JSX.Element => {
  const image: IStaticContentfulImages = useStaticQuery(graphql`
    {
      success: contentfulAsset(contentful_id: { eq: "29QMRXkQlfQtnv9xPx8Qsz" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 24)
      }
      failure: contentfulAsset(contentful_id: { eq: "2OQybw3M2FCaTlSU1PiJFs" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 24)
      }
    }
  `);

  const textOptions = {
    success: 'Thanks! Keep an eye on your inbox.',
    failure: 'Something went wrong, please try again later.',
  };

  return (
    <FormResultContainer result={result}>
      <GatsbyImage
        image={image[result].gatsbyImageData}
        alt={result}
      />
      <Paragraph
        text={textOptions[result]}
        align='center'
        standardSize='1'
        weight='light'
      />
    </FormResultContainer>
  );
};

export default HubspotFormResult;
